import AbstractApi from "services/cores/abstractApi";
import paths from "routes/paths";

const NonMovingCarsApi = new AbstractApi({
  paths: {
    default: paths.api.parkStatistics.dataByRadius.nonMovingCars,
    byAreas: paths.api.parkStatistics.dataByAreas.nonMovingCars,
    byRadius: paths.api.parkStatistics.dataByRadius.nonMovingCars,
  },
});

export default NonMovingCarsApi;
